import React from 'react'
import CustomDialog from '../../components/common/CustomDialog'
import { CiSettings } from "react-icons/ci";
import CustomTab from '../../components/common/CustomTab';
import Tabs from './Tabs';
import CompanyTab from './CompanyTab';
import CategoryTab from './CategoryTab';

const AccessModal = ({open,setOpen,componytabdata,catagorydata,dep,setDep, id}) => {
  console.log('dd2',catagorydata,componytabdata);
  
  return (
    <CustomDialog
    open={open}
    setOpen={setOpen}
    noTitleWrapper={true}
    className="mt-0"
    width={"70vw"}
    // height={"80vh"}
  >
    <div className='mt-0 mb-2 flex p-2 justify-between items-center bg-[#0051AD]'>
        <div className='flex gap-2 items-center'>
            <CiSettings />
            <p className='text-white font-semibold'>Access</p>

        </div>
        <div>
            <p className='text-white underline cursor-pointer' onClick={()=>setOpen(false)}>close</p>
        </div>

    </div>
    <CustomTab
    tabList={[
      { title: "Tabs", startIcon: null, endIcon: null, component: <Tabs  setDep={setDep} dep={dep} id={id}  /> },
      { title: "Company", startIcon: null, endIcon: null, component: <CompanyTab data={componytabdata} setDep={setDep} id={id}/> },
      { title: "Categories", startIcon: null, endIcon: null, component: <CategoryTab data={catagorydata} setDep={setDep}id={id} /> },

    ]}
    tabIndex={0}
  />

  </CustomDialog>
  )
}

export default AccessModal